import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/returns-exchanges")({
  beforeLoad: () => {
    throw redirect({ to: "/return-and-exchange", replace: true, statusCode: 301 });
  },
});
